var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.00195312C2.69178 0.00195312 6.10828e-05 2.69368 6.10828e-05 5.99814C-0.0216887 10.8318 5.772 14.8398 6 15.0018C6 15.0018 12.0217 10.8318 11.9999 6.00189C11.9999 2.69368 9.30822 0.00195312 6 0.00195312ZM6 9.00186C4.34252 9.00186 3.00003 7.65938 3.00003 6.00189C3.00003 4.34441 4.34252 3.00192 6 3.00192C7.65748 3.00192 8.99997 4.34441 8.99997 6.00189C8.99997 7.65938 7.65748 9.00186 6 9.00186Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map_marker.a224f4df80896cf7e276adbd3cb6ac92.svg";
export { ForwardRef as ReactComponent };